import { LitElement, html, css } from 'lit'
import { consume } from '@lit/context'
import { breakpointContext, isSubMenuOpenContext, navigationContext } from '../context.ts'
import { customElement } from 'lit/decorators.js'
import { TW, type Breakpoint, type MenuItem } from '../../../shared'

const TwLitElement = TW(LitElement)

/**
 * Sample Lit Element in assets/lit
 */
@customElement('mobile-navigation')
export class MobileNavigation extends TwLitElement {

    @consume({context: navigationContext, subscribe: true})
    private _data: MenuItem[] = []

    @consume({context: breakpointContext, subscribe: true}) 
    private _breakpoint: Breakpoint | null = null

    @consume({context: isSubMenuOpenContext, subscribe: true})
    private _isSubMenuOpen: boolean = false

    static styles = css`
        :host([hidden]) {
            display: none;
        }
    `

    private _isShown() 
    {
        return this._isSubMenuOpen 
            && [ 'xs', 'sm', 'md', 'lg' ].includes( this._breakpoint?.name ?? '' ) // Wann soll die Navigation angezeigt werden?
    }

    render() 
    {
        if ( ! this._isShown() ) {
            this.setAttribute( 'hidden', '' );
            return html``
        }

        this.removeAttribute( 'hidden' );

        // Mobile Navigation: 
        // - Falls kein MenuItem aktiv ist, wird Level 0 der Navigation angezeigt
        // - Falls ein oder mehrere MenuItem aktiv sind, werden zuerst die aktiven MenuItems aufgelistet und danach die Kinder des aktiven MenuItems mit dem größten Level

        const activeItems = this._data.filter( item => item.active ).sort( (a: MenuItem, b: MenuItem) => a.level - b.level )

        // Kein Aktives MenuItem => Level 0 der Navigation anzeigen
    
        if ( activeItems.length < 1 ) {
            return html`<nav class="py-6 container" aria-label="Hauptmenü">
                <ul class="alignwide">
                    ${ this._data.filter( item => item.level === 0 ).map( 
                        item => html`<li><menu-item id=${item.id}></menu-item></li>`
                    ) }
                </ul>
            </nav>`
        }

        // Mindestens ein aktives MenuItem => Wir gehen die aktiven MenuItems durch und zeigen am Ende die Kinder des letzten (tiefsten) aktiven MenuItems

        const lastActiveItem = activeItems[ activeItems.length - 1 ]
        const childrenOfLastActiveItem = this._data.filter( item => item.parentId === lastActiveItem.id )

        return html`<nav class="py-6 container" aria-label="Hauptmenü">
            <ul class="alignwide">
                ${ activeItems.map( item => html`
                    <li class="pb-2 border-b border-b-[rgb(187,187,187)] mb-2">
                        <menu-item id=${item.id} sub-menu-icon-position="before" sub-menu-icon="bmw-icon-arrow-chevron-left-rg"></menu-item>
                    </li>
                ` ) }
                ${ childrenOfLastActiveItem.map( item => html`
                    <li><menu-item id=${item.id}></menu-item></li>` 
                ) }
            </ul>
        </nav>`
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'mobile-navigation': MobileNavigation
    }
}
